/**
 * Mein Profil - JavaScript
 *
 * Collapsible-Sektionen, Passwort-Modal, Country/State Wechsel
 *
 * @package Brandner_Custom
 * @since 2.0.0
 * @version 11.0.0
 */
(function($) {
    'use strict';

    function initProfile() {

        // =====================================================================
        // Collapsible Sections Toggle
        // =====================================================================

        $('.brandner-collapsible-toggle').off('click.brandnerProfile').on('click.brandnerProfile', function() {
            var $btn = $(this);
            var expanded = $btn.attr('aria-expanded') === 'true';
            var targetId = $btn.attr('aria-controls');
            var $content = $('#' + targetId);

            $btn.attr('aria-expanded', !expanded);

            if (expanded) {
                $content.attr('hidden', '');
            } else {
                $content.removeAttr('hidden');
            }
        });

        // =====================================================================
        // Passwort-Modal
        // =====================================================================

        var $modal = $('#brandner-password-modal');
        var $openBtn = $('#brandner-open-password-modal');
        var $closeBtn = $('#brandner-close-password-modal');
        var $confirmBtn = $('#brandner-confirm-password-modal');

        function openPasswordModal() {
            $modal.removeAttr('hidden');
            $('body').css('overflow', 'hidden');
            setTimeout(function() {
                $('#password_current').trigger('focus');
            }, 100);
        }

        function closePasswordModal() {
            $modal.attr('hidden', '');
            $('body').css('overflow', '');
        }

        $openBtn.off('click.brandnerProfile').on('click.brandnerProfile', openPasswordModal);
        $closeBtn.off('click.brandnerProfile').on('click.brandnerProfile', closePasswordModal);

        // Confirm: schliesse Modal (Werte bleiben in den Feldern fuer Form-Submit)
        $confirmBtn.off('click.brandnerProfile').on('click.brandnerProfile', closePasswordModal);

        // Overlay-Click schliesst Modal
        $modal.off('click.brandnerProfile').on('click.brandnerProfile', function(e) {
            if (e.target === this) {
                closePasswordModal();
            }
        });

        // =====================================================================
        // Change-Request Modal (Identity Lock)
        // =====================================================================

        var $changeModal = $('#brandner-change-request-modal');
        var $changeOpenBtn = $('#brandner-open-change-request');
        var $changeCloseBtn = $('#brandner-close-change-request');
        var $changeSendBtn = $('#brandner-send-change-request');
        var $changeMessage = $('#brandner-change-request-message');
        var $changeSuccess = $('#brandner-change-request-success');
        var $changeFooter = $('#brandner-change-request-footer');

        function openChangeRequestModal() {
            $changeModal.removeAttr('hidden');
            $changeMessage.val('').prop('disabled', false);
            $changeSuccess.attr('hidden', '');
            $changeFooter.show();
            $changeSendBtn.prop('disabled', false).text('Anfrage senden');
            $('body').css('overflow', 'hidden');
            setTimeout(function() { $changeMessage.trigger('focus'); }, 100);
        }

        function closeChangeRequestModal() {
            $changeModal.attr('hidden', '');
            $('body').css('overflow', '');
        }

        $changeOpenBtn.off('click.brandnerProfile').on('click.brandnerProfile', openChangeRequestModal);
        $changeCloseBtn.off('click.brandnerProfile').on('click.brandnerProfile', closeChangeRequestModal);

        // Overlay-Click schliesst Modal
        $changeModal.off('click.brandnerProfile').on('click.brandnerProfile', function(e) {
            if (e.target === this) {
                closeChangeRequestModal();
            }
        });

        // AJAX senden
        $changeSendBtn.off('click.brandnerProfile').on('click.brandnerProfile', function() {
            var message = $changeMessage.val().trim();
            if (!message) {
                $changeMessage.css('border-color', '#e74c3c').trigger('focus');
                setTimeout(function() { $changeMessage.css('border-color', ''); }, 2000);
                return;
            }

            $changeSendBtn.prop('disabled', true).text('Wird gesendet...');

            $.ajax({
                url: brandnerProfile.ajaxUrl,
                type: 'POST',
                data: {
                    action: 'brandner_identity_change_request',
                    nonce: brandnerProfile.identityLockNonce,
                    message: message
                },
                success: function(response) {
                    if (response.success) {
                        $changeMessage.prop('disabled', true);
                        $changeFooter.hide();
                        $changeSuccess.removeAttr('hidden');
                    } else {
                        $changeSendBtn.prop('disabled', false).text('Anfrage senden');
                        alert(response.data && response.data.message ? response.data.message : 'Fehler beim Senden.');
                    }
                },
                error: function() {
                    $changeSendBtn.prop('disabled', false).text('Anfrage senden');
                    alert('Verbindungsfehler. Bitte versuchen Sie es erneut.');
                }
            });
        });

        // ESC schliesst Modals (namespaced to avoid duplicates)
        $(document).off('keydown.brandnerProfile').on('keydown.brandnerProfile', function(e) {
            if (e.key === 'Escape') {
                if (!$modal.is('[hidden]')) {
                    closePasswordModal();
                }
                if ($agbModal.is(':visible')) {
                    closeAgbModal();
                }
                if (!$changeModal.is('[hidden]')) {
                    closeChangeRequestModal();
                }
            }
        });

        // =====================================================================
        // Country/State Wechsel
        // =====================================================================

        var $country = $('#billing_country');
        var $stateWrap = $('.brandner-profile-field-state');
        var $state = $('#billing_state');
        var states = (typeof brandnerProfile !== 'undefined' && brandnerProfile.states) ? brandnerProfile.states : {};
        var i18n = (typeof brandnerProfile !== 'undefined' && brandnerProfile.i18n) ? brandnerProfile.i18n : {};

        $country.off('change.brandnerProfile').on('change.brandnerProfile', function() {
            var countryCode = $(this).val();
            var countryStates = states[countryCode];

            if (countryStates && Object.keys(countryStates).length > 0) {
                var $select = $('<select>', { name: 'billing_state', id: 'billing_state' });
                $select.append($('<option>', { value: '', text: i18n.selectState || 'Bundesland waehlen...' }));

                $.each(countryStates, function(code, name) {
                    $select.append($('<option>', { value: code, text: name }));
                });

                $state.replaceWith($select);
                $state = $select;
                $stateWrap.show();
            } else {
                // Guard: auf Seiten ohne #billing_state (z.B. Profil-Vervollstaendigung)
                // ist $state leer — prop('tagName') waere undefined und wuerfe einen
                // TypeError, der alle weiteren change-Handler abbricht
                if ($state.length && $state.prop('tagName').toLowerCase() === 'select') {
                    var $input = $('<input>', { type: 'text', name: 'billing_state', id: 'billing_state', value: '' });
                    $state.replaceWith($input);
                    $state = $input;
                }
                $stateWrap.hide();
            }
        });

        // =====================================================================
        // AGB-Modal
        // =====================================================================

        var $agbModal = $('#brandner-agb-modal');
        var $agbBtn = $('#brandner-agb-btn');
        var $agbAcceptBtn = $('#brandner-agb-modal-accept');
        var $agbCloseBtn = $('#brandner-agb-modal-close');

        function openAgbModal() {
            var $body = $('#brandner-agb-modal-body');
            var $hint = $('#brandner-agb-modal-hint');

            $agbAcceptBtn.addClass('is-disabled');
            $hint.text('Bitte scrollen Sie bis zum Ende der AGB.');

            // fadeIn mit Callback - Scroll-Check erst nach vollstaendigem Layout
            $agbModal.fadeIn(300, function() {
                var el = $body[0];

                // Pruefen ob Inhalt ueberhaupt scrollbar ist
                if (el.scrollHeight <= el.clientHeight) {
                    // Inhalt passt komplett rein - sofort aktivieren
                    $agbAcceptBtn.removeClass('is-disabled');
                    $hint.text('Sie k\u00f6nnen die AGB jetzt akzeptieren.');
                    return;
                }

                // Scroll-Event: Button aktivieren wenn Bottom erreicht
                $body.off('scroll.agb').on('scroll.agb', function() {
                    var scrollTop = el.scrollTop;
                    var scrollHeight = el.scrollHeight;
                    var clientHeight = el.clientHeight;
                    // 20px Toleranz
                    if (scrollTop + clientHeight >= scrollHeight - 20) {
                        $agbAcceptBtn.removeClass('is-disabled');
                        $hint.text('Sie k\u00f6nnen die AGB jetzt akzeptieren.');
                        $body.off('scroll.agb');
                    }
                });
            });

            $('body').css('overflow', 'hidden');
        }

        function closeAgbModal() {
            $agbModal.fadeOut(200);
            $('body').css('overflow', '');
            $('#brandner-agb-modal-body').off('scroll.agb');
        }

        function acceptAgb() {
            // Hidden-Input setzen
            $('#brandner_agb_accepted').val('1');

            // Status-HTML zu gruenem Badge wechseln
            $('#brandner-agb-status-wrap').html(
                '<span class="brandner-agb-badge brandner-agb-badge--accepted">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
                ' Akzeptiert' +
                '</span>'
            );

            closeAgbModal();
        }

        // AGB-Button oeffnet Modal
        $agbBtn.off('click.brandnerProfile').on('click.brandnerProfile', function() {
            openAgbModal();
        });

        // Modal schliessen
        $agbCloseBtn.off('click.brandnerProfile').on('click.brandnerProfile', closeAgbModal);

        // Overlay-Click schliesst Modal
        $agbModal.off('click.brandnerProfile').on('click.brandnerProfile', function(e) {
            if ($(e.target).is('#brandner-agb-modal')) {
                closeAgbModal();
            }
        });

        // Accept Button
        $agbAcceptBtn.off('click.brandnerProfile').on('click.brandnerProfile', function() {
            if ($(this).hasClass('is-disabled')) {
                var $hint = $('#brandner-agb-modal-hint');
                $hint.addClass('brandner-hint-highlight');
                setTimeout(function() {
                    $hint.removeClass('brandner-hint-highlight');
                }, 1500);
                return;
            }
            acceptAgb();
        });

    }

    /**
     * Cleanup: remove body overflow, namespaced events
     */
    function destroyProfile() {
        $('body').css('overflow', '');
        $(document).off('keydown.brandnerProfile');
    }

    // Expose for PJAX
    window.BrandnerProfileInit = initProfile;
    window.BrandnerProfileDestroy = destroyProfile;

    $(function() {
        initProfile();
    });

})(jQuery);
